export const hoverable = `@media (hover: hover)`;
